'use client'

import NextLink from '@/components/NextLink';
import { faBookmark, faSuitcase, faTicket, faUser } from '@fortawesome/pro-regular-svg-icons';
import { faUser as faUserSolid, faHomeAlt as faHomeAltSolid, faBookmark as faBookmarkSolid, faSuitcase as faSuitcaseSolid, faTicket as faTicketSolid } from '@fortawesome/pro-solid-svg-icons';
import { faHomeAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePathname } from 'next/navigation';
import { useUserStore } from '@/core/stores/user';
import useNextRouter from '@/hooks/useNextRouter';
import { useAuthenticationModalStore } from '@/core/stores/auth';
import Image from 'next/image';
import useAppStore from '@/core/stores/app';

export default function MobileNav() {
    const pathname = usePathname()
    const { _id, image } = useUserStore()
    const { push, } = useNextRouter()
    const { setShowAuthModal } = useAuthenticationModalStore()
    const { isApp } = useAppStore()

    return !pathname.includes('/itineraries/') && isApp && (<>
        <div className='h-14'>

        </div>
        <div className='bg-white shadow-card-top-sm z-50 w-full font-normal text-neutral-500 fixed bottom-0 left-0 py-3.5 px-4 grid grid-cols-5'>
            <button onClick={() => {
                push('/')
            }} className={`${pathname === '/app' ? 'text-indigo-500' : ''} flex flex-col gap-1 text-xs items-center`}
            >
                {pathname === '/app' ?
                    <FontAwesomeIcon className='text-indigo-500 h-4' icon={faHomeAltSolid} /> :
                    <FontAwesomeIcon className='h-4' icon={faHomeAlt} />
                }
                <span>Home</span>
            </button>
            <button onClick={() => {
                if (!_id) {
                    setShowAuthModal(true)
                    return
                }
                push('/profile/saved/hotels')
            }} className={`${pathname === '/profile/saved/hotels' ? 'text-indigo-500' : ''} flex flex-col gap-1 text-xs items-center`}
            >
                {pathname === '/profile/saved/hotels' ? <FontAwesomeIcon className='text-indigo-500 h-4' icon={faBookmarkSolid} /> : <FontAwesomeIcon className='h-4' icon={faBookmark} />}
                <span>Saved</span>
            </button>
            <button onClick={() => {
                if (!_id) {
                    setShowAuthModal(true)
                    return
                }
                push('/profile/my-trips')
            }} className={`${pathname === '/profile/my-trips' ? 'text-indigo-500' : ''} flex flex-col gap-1 text-xs items-center`}
            >
                {pathname === '/profile/my-trips' ? <FontAwesomeIcon className='text-indigo-500 h-4' icon={faSuitcaseSolid} /> : <FontAwesomeIcon className='h-4' icon={faSuitcase} />}
                <span>Trips</span>
            </button>
            <button onClick={() => {
                if (!_id) {
                    setShowAuthModal(true)
                    return
                }
                push('/profile/orders')
            }} className={`${pathname === '/profile/orders' ? 'text-indigo-500' : ''} flex flex-col gap-1 text-xs items-center`}

            >
                {pathname === '/profile/orders' ? <FontAwesomeIcon className='text-indigo-500 h-4' icon={faTicketSolid} /> : <FontAwesomeIcon className='h-4' icon={faTicket} />}
                <span>Booking</span>
            </button>
            <button onClick={() => {
                if (!_id) {
                    setShowAuthModal(true)
                    return
                }
                push('/profile')
            }} className={`${pathname === '/profile' ? 'text-indigo-500' : ''} flex flex-col gap-1 text-xs items-center`}
            >
                {image ? <Image src={image} alt="Planingo" width={50} height={50} className='w-4 aspect-square rounded-full' /> : pathname === '/profile' ? <FontAwesomeIcon className='text-indigo-500 h-4' icon={faUserSolid} /> : <FontAwesomeIcon className='h-4' icon={faUser} />}
                <span>Profile</span>
            </button>
        </div>
    </>
    );
}

function MobileNvButton() {

}